import { render, staticRenderFns } from "./articleStream.vue?vue&type=template&id=216b8728&scoped=true&"
import script from "./articleStream.vue?vue&type=script&lang=js&"
export * from "./articleStream.vue?vue&type=script&lang=js&"
import style0 from "./articleStream.vue?vue&type=style&index=0&id=216b8728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b8728",
  null
  
)

export default component.exports